// extracted by mini-css-extract-plugin
module.exports = {"control":"Control_control__33jMX"};